import { Dialog, styled } from '@mui/material';

const SidePanelDialog = styled(Dialog)(() => ({
	'& .MuiDialog-container': {
		justifyContent: 'flex-end',
		alignItems: 'stretch',
	},
	'& .MuiPaper-root': {
		margin: 0,
		height: '100vh',
		width: '550px',
		maxWidth: 'none',
		borderRadius: 0,
	},
}));

export default SidePanelDialog;
